<!--  -->
<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<el-form ref="searchEmp" :model="searchEmp" class="searchEmp">
				<el-row>
					<el-col :xs="24" :sm="13" :md="13" :lg="12">
						<el-form-item label-width="70px">
							<div slot="label">报修时间</div>
							<el-date-picker v-model="searchEmp.time" type="datetimerange" align="right" start-placeholder="开始日期"
								end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="12" style="float:right">
						<el-row style="text-align:end;width:100%">
							<el-button type="success" @click="show('add')">新增</el-button>
							<el-button type="info" @click="clean_btn">重置</el-button>
							<el-button type="primary" @click="search_btn">查询</el-button>
						</el-row>
					</el-col>
				</el-row>
			</el-form>

			<Total :total="total"></Total>

			<!-- 表格 -->

			<el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F1F2F7', color: '#606266' }">
				<el-table-column prop="baoxiuren" label="报修联系人" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="phone" label="企业联系电话" min-width="120" align="center">
				</el-table-column>
				<el-table-column label="维护状态" min-width="100" align="center">
					<template slot-scope="scope">
						<el-tag v-if="formatCwstatus(scope.row.cwstatus) === '接单中'" effect="dark">{{
							formatCwstatus(scope.row.cwstatus)
						}}</el-tag>
						<el-tag v-if="formatCwstatus(scope.row.cwstatus) === '维修中'" type="warning" effect="dark">{{
							formatCwstatus(scope.row.cwstatus)
						}}</el-tag>
						<el-tag v-if="formatCwstatus(scope.row.cwstatus) === '已完成'" type="success" effect="dark">{{
							formatCwstatus(scope.row.cwstatus)
						}}</el-tag>
						<el-tag v-if="formatCwstatus(scope.row.cwstatus) === '已归档'" type="info" effect="dark">{{
							formatCwstatus(scope.row.cwstatus)
						}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="cwdate" label="报修时间" min-width="160" align="center" :formatter="formatDate">
				</el-table-column>
				<el-table-column prop="cwcompletiontime" label="完成时间" min-width="160" align="center" :formatter="formatDate">
				</el-table-column>
				<el-table-column label="操作" align="center" fixed="right" width="200">
					<template slot-scope="scope">
						<el-button class="revise" type="primary" plain @click="details(scope.row.cwid, scope.row.cwstatus)"
							style="z-index:999">详情</el-button>
						<el-button v-if="formatCwstatus(scope.row.cwstatus) === '维修中'" class="revise" type="warning" plain
							@click="show('confirm', scope.row.cwid)" style="z-index:999">确认完成</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->

			<div class="page">
				<el-pagination v-if="tableData.length != 0" class="fy" style="" layout="prev, pager, next" :total="total"
					:page-size="pageData.page_size" :current-page="pageData.page_no" @current-change="current_change" background>
				</el-pagination>
			</div>
		</el-card>

		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisible" center width="35%" :before-close="hide">
			<template #title>
				<div
					style="font-size: 20px;font-weight: 500;color: #6345d5;border-bottom:1px  #6345d5 solid;padding-bottom: 10px;">
					{{ visibleTitle }}
				</div>
			</template>
			<div class="form">
				<template v-if="visibleState === 'add'">
					<el-form :model="addForm" ref="addFormRef" :rules="addFormRules" label-width="auto" style="width:500px;">
						<el-form-item label="报修联系人" prop="contacts">
							<el-input v-model.trim="addForm.contacts" autofocus />
						</el-form-item>
						<el-form-item label="企业联系电话" prop="tel">
							<el-input v-model="addForm.tel" />
						</el-form-item>
						<el-form-item label="故障描述" prop="describe">
							<el-input v-model="addForm.describe" clearable type="textarea" showWordLimit resize="none" maxlength="120"
								rows="3" />
						</el-form-item>

					</el-form>
				</template>
				<template v-else>
					<el-form :model="confirmForm" ref="confirmFormRef" :rules="confirmFormRules" label-width="auto"
						style="width:500px;">
						<el-form-item label="维护类型" prop="types">
							<el-select v-model="confirmForm.types" placeholder="请选择" style="width: 100%;">
								<el-option v-for="item in typesOptions" :key="item.bscode" :label="item.bsname" :value="item.bscode">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="确认人">
							<el-input v-model.trim="confirmForm.confirmren" autofocus />
						</el-form-item>
						<el-form-item label="确认人电话" prop="confirmtel">
							<el-input v-model="confirmForm.confirmtel" />
						</el-form-item>
						<el-form-item label="评分内容">
							<div class="star"><span>维修技术</span><el-rate v-model="confirmForm.pfjishu" /></div>
							<div class="star"><span>服务态度</span><el-rate v-model="confirmForm.pftd" /></div>
							<div class="star"><span>处理速度</span><el-rate v-model="confirmForm.pfsd" /></div>

						</el-form-item>

					</el-form>
				</template>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">取 消</el-button>
				<el-button type="primary" @click="submit" :loading="submitBtnLoading">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Total from '@/components/total/index.vue'
import { regular } from '@/utils/validate'
import { getRefined, addRefined, updataRefined, getTypes } from '@/api/day_work'
// import { lists, filtersInfo } from '@/utils/dictionary.js'
// import { formatDate } from '@/utils/index.js'

export default {
	//import引入的组件需要注入到对象中才能使用
	name: 'Refined',
	components: { Total },
	data() {
		//这里存放数据
		return {
			breadcrumbList: [
				{ name: "运维管理", path: "refined" }
			],
			total: 0,
			pageData: {
				page_no: 1,  //现在
				page_size: 10, //每页条数
			},
			searchEmp: {
				time: [],
				nohotel: ''
			},
			tableData: [],

			setate: ['报修', '维护', '确认完成', '完成'],

			visibleTitle: '新增维护记录',
			dialogVisible: false,
			visibleState: 'add',  // "add" / "confirm"

			addFormRef: '',
			addForm: {
				action: 'amaintain',
				category: '06',
				hotelCode: '',
				contacts: '',
				tel: '',
				describe: '',
			},
			addFormRules: {
				contacts: [
					{ required: true, message: '请输入报修联系人', trigger: 'blur' }
				],
				tel: [
					{ required: true, message: '请输入企业联系电话', trigger: 'blur' },
					{
						pattern: regular.phone,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}
				],
				describe: [
					{ required: true, message: '请输入故障描述', trigger: 'blur' }
				]
			},
			confirmForm: {
				action: 'aupdateend',
				cwid: 0,
				types: '',
				confirmren: '',
				confirmtel: '',
				pfjishu: 3,//技术
				pftd: 3,//态度
				pfsd: 3,//速度
			},
			confirmFormRules: {
				types: [
					{ required: true, message: '请选择维护类型', trigger: 'change' }
				],
				confirmtel: [
					{ required: true, message: '请输入确认人手机号码', trigger: 'blur' },
					{
						pattern: regular.phone,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}
				],
			},
			typesOptions: [],
			confirmFormRef: '',
			submitBtnLoading: false,
		}
	},
	//方法集合
	methods: {
		async info() {
			// const csdm = '3333333333'
			const csdm = this.$store.getters.basicInfo.csdm
			this.searchEmp.nohotel = csdm
			this.addForm.hotelCode = csdm
			const typesList = await getTypes()
			this.typesOptions = typesList.data
			console.log('this.typesOptions', this.typesOptions);
			const res = await getRefined(this.searchEmp.nohotel, this.pageData.page_no, this.pageData.page_size, this.searchEmp.sdate, this.searchEmp.edate)
			this.tableData = res.data.data
			// 数据处理 - 由于后端加不了字段 , 在此作额外判断
			this.tableData.forEach(item => {
				console.log('列表item', item.cwfaultmark);
				const isLianxiren = item.cwfaultmark.indexOf('联系人：') > -1
				const isPhone = item.cwfaultmark.indexOf('联系电话：') > -1
				console.log('isLianxiren', isLianxiren);
				if (item.cwfaultmark.indexOf('||') > -1) {
					item.cwfaultmark = item.cwfaultmark.split('||')
					if (isLianxiren) {
						item['baoxiuren'] = item.cwfaultmark[2].split('：')[1]
					}
					if (isPhone) {
						item['phone'] = item.cwfaultmark[1].split('：')[1]
					}
				}
			})
			this.total = res.data.pageinfo[0].pagesize
			console.log(this.tableData);
		},

		async submit() {
			console.log(this.visibleState);
			this.submitBtnLoading = true
			if (this.visibleState === 'add') {
				this.$refs['addFormRef'].validate(async (valid) => {
					if (valid) {
						const res = await addRefined(this.addForm)
						if (res.data.message.indexOf('ok') > -1) {
							this.$message({
								message: '新增维护记录成功！',
								type: 'success'
							});
							this.hide()
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					} else {
						console.log('error submit!!')
						return false
					}
				})


			} else if (this.visibleState === 'confirm') {
				console.log('’确认');
				this.$refs['confirmFormRef'].validate(async (valid) => {
					if (valid) {
						const res = await updataRefined(this.confirmForm)
						if (res.data.message.indexOf('ok') > -1) {
							this.$message({
								message: '确认完成成功！',
								type: 'success'
							});
							this.hide()
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					} else {
						console.log('error submit!!')
						return false
					}
				})

			}
			this.submitBtnLoading = false
			this.info()
		},

		// ========= dialog  显示与隐藏 ========
		show(visibleState, cwid) {
			this.visibleState = visibleState
			this.dialogVisible = true

			if (this.visibleState === 'add') {
				this.visibleTitle = '新增维护记录'
				this.addForm.tel = this.$store.getters.userInfo.mobile
			} else if (this.visibleState === 'confirm') {
				this.confirmForm.cwid = cwid
				this.visibleTitle = '确认完成'
			}
		},
		// 隐藏清除表单数据
		hide() {
			this.dialogVisible = false
			if (this.$refs['addFormRef'] !== undefined) {
				this.$refs['addFormRef'].resetFields()
			}
			if (this.$refs['confirmFormRef'] !== undefined) {
				this.$refs['confirmFormRef'].resetFields()
			}
			this.addForm.contacts = ''
			this.addForm.tel = this.$store.getters.userInfo.mobile
			this.addForm.describe = ''
			this.confirmForm = {
				action: 'aupdateend',
				cwid: 0,
				types: '',
				confirmren: '',
				confirmtel: '',
				pfjishu: 3,//技术
				pftd: 3,//态度
				pfsd: 3,//速度
			}

		},
		// ========= dialog  显示与隐藏 ========
		clean_btn() { //重置
			this.searchEmp = {}
			this.info()
		},
		search_btn() { //查询
			// 当前页强制转为1
			this.pageData.page_no = 1
			const time = this.searchEmp.time
			console.log(time);
			this.searchEmp.sdate = time ? time[0] : ''
			this.searchEmp.edate = time ? time[1] : ''
			this.info()
		},
		details(id, type) { //点击单元格,跳转详情
			this.$router.push({
				path: '/refined/refined_details',
				query: { id, type }
			})
		},
		current_change(val) { //分页功能
			this.pageData.page_no = val
			this.info()
		},
		formatDate(row, col, val) {
			if (!val && val != 0) return
			let tempString = val.replace("T", " ")
			if (tempString.includes('.')) {
				tempString = tempString.split('.')[0]
			}
			return tempString
		},
		formatCwstatus(val) {
			if (!val && val != 0) return
			let temp = ''
			switch (val) {
				case '报修':
					temp = '接单中'
					break;
				case '维护':
					temp = '维修中'
					break;
				case '派单':
					temp = '维修中'
					break;
				case '确认完成':
					temp = '已完成'
					break;
				case '完成':
					temp = '已归档'
					break;

			}
			return temp
		}
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	async created() {
		this.info()
	},
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类

.form {
	display: flex;
	justify-content: center;
}

::v-deep .el-input__count {
	background-color: transparent !important;
	bottom: -10px;
	right: 20px;
}

.star {
	display: flex;
	align-items: baseline;

	span {
		padding: 0 20px;
	}
}
</style>